import { Box } from '@mui/system';
import styled from '@mui/system/styled';

export const ContentCnt = styled('div')({
  padding: '0',
  '& ul': {
    paddingLeft: '24px',
    marginTop: '8px',
  },
});
export const DialogCnt = styled(Box)({
  '& ul': {
    marginBottom: '20px',
    '& li': {
      listStyle: 'disc',

      mb: 1,
      fontWeight: 500,
      fontSize: '16px',
    },
  },
});
